import { z } from '@/utils/zod'

import { OAuthBaseAuthProviderSchema } from './OAuthBaseAuthProvider'

export const MicrosoftAuthProviderTypeSchema = z.literal('microsoft')

export type MicrosoftAuthProviderType = z.infer<typeof MicrosoftAuthProviderTypeSchema>

export const MicrosoftAuthProviderSchema = OAuthBaseAuthProviderSchema.extend({
    type: MicrosoftAuthProviderTypeSchema,
    emailVerification: z.toggleable({
        requirement: z.enum(['optional', 'required']),
        tokenTtl: z.number().min(1), // seconds
        resendWait: z.number().min(15), // seconds
    }),
    // recoverAccountFrom: z.enum(['sub', 'email']),
})

export type MicrosoftAuthProvider = z.infer<typeof MicrosoftAuthProviderSchema>
